"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyTermFields = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
var react_1 = __importStar(require("react"));
var policy_term_select_1 = require("../policy-term-select");
function PolicyTermFields(_a) {
    var _b, _c, _d, _e;
    var values = _a.values, errors = _a.errors, onChange = _a.onChange, _f = _a.labels, labels = _f === void 0 ? {
        policyTerm: 'Policy term',
        effectiveDate: 'Effective date',
        expirationDate: 'Expiration date',
    } : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g;
    var isDisabled = disabled;
    var policyTermDisabled = !!values.policyTerm;
    react_1.useEffect(function () {
        var _a;
        if (values.policyTerm) {
            onChange(__assign(__assign({}, values), { policyTerm: values.policyTerm, expirationDate: getExpirationDateByEffectiveDate((_a = values.effectiveDate) !== null && _a !== void 0 ? _a : '', values.policyTerm) }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.policyTerm, values.effectiveDate]);
    return (react_1.default.createElement(core_ui_1.Stack, { gap: 16, direction: "vertical" },
        react_1.default.createElement(core_ui_1.Field, { fieldId: "coverage-policy-term", label: (_b = labels.policyTerm) !== null && _b !== void 0 ? _b : 'Policy term', error: errors === null || errors === void 0 ? void 0 : errors.policyTerm },
            react_1.default.createElement(policy_term_select_1.PolicyTermSelect, { onChange: function (policyTerm) {
                    var _a;
                    onChange(__assign(__assign({}, values), { policyTerm: policyTerm, expirationDate: getExpirationDateByEffectiveDate((_a = values.effectiveDate) !== null && _a !== void 0 ? _a : '', policyTerm) }));
                }, value: values.policyTerm, disabled: isDisabled })),
        react_1.default.createElement(core_ui_1.Stack, { gap: 16, isFluid: true },
            react_1.default.createElement(core_ui_1.Field, { fieldId: "coverage-effective-date", label: (_c = labels.effectiveDate) !== null && _c !== void 0 ? _c : 'Effective date', error: errors === null || errors === void 0 ? void 0 : errors.effectiveDate },
                react_1.default.createElement(core_ui_1.DatePickerInput2.Controlled, { value: values.effectiveDate, testId: "effective-date", timezone: "UTC", format: "MM/DD/YYYY", onChange: function (date) {
                        onChange(__assign(__assign({}, values), { effectiveDate: date, expirationDate: getExpirationDateByEffectiveDate(date !== null && date !== void 0 ? date : '', values.policyTerm) }));
                    }, disabled: isDisabled })),
            react_1.default.createElement(core_ui_1.Field, { fieldId: "coverage-expiration-date", label: (_d = labels.expirationDate) !== null && _d !== void 0 ? _d : 'Expiration date', error: errors === null || errors === void 0 ? void 0 : errors.expirationDate },
                react_1.default.createElement(core_ui_1.DatePickerInput2.Controlled, { value: values.expirationDate, minDate: (_e = values.effectiveDate) !== null && _e !== void 0 ? _e : '', testId: "expiration-date", timezone: "UTC", format: "MM/DD/YYYY", onChange: function (date) {
                        onChange(__assign(__assign({}, values), { expirationDate: date }));
                    }, disabled: policyTermDisabled || isDisabled })))));
}
exports.PolicyTermFields = PolicyTermFields;
function getExpirationDateByEffectiveDate(effectiveDate, policyTerm) {
    if (!policyTerm || !effectiveDate) {
        return '';
    }
    if (!date_fns_1.isValid(new Date(effectiveDate))) {
        return '';
    }
    var expirationDate = date_fns_1.addMonths(date_fns_tz_1.utcToZonedTime(effectiveDate, 'UTC'), policyTerm);
    return date_fns_tz_1.zonedTimeToUtc(expirationDate, 'UTC').toISOString();
}
